import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import { Workspace } from '@app/shared/store/entities';
import { DEFAUTL_WORKSPACE_PLACEHOLDER } from '../../workspace.module';
import { fuseAnimations } from '@keeps-platform-frontend-workspace/layout';
@Component({
  selector: 'app-workspace-page-wrapper',
  templateUrl: './workspace-page-wrapper.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  animations: fuseAnimations,
  standalone: false,
})
export class WorkspacePageWrapperComponent {
  placeholder = DEFAUTL_WORKSPACE_PLACEHOLDER;
  @Input() workspace: Workspace;
}
